module.exports = __webpack_public_path__ + "img/party-2010-branch.bbb7387d.jpg";